export default (that) => [
  {
    field: 'opt',
    align: 'left',
    fixed: 'right',
    width: 160,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('goods_label_orderGoodsColor') || '产品颜色',
    field: 'orderGoodsColor',
    width: 150,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
    editRender: {
      name: 'input',
      attrs: {
        type: 'String',
        placeholder:
          that.$l('tips_goods_label_orderGoodsColor') || '请输入产品颜色',
        maxlength: 50,
      },
    },
  },
  {
    title: that.$l('goods_label_orderGoodsColorEn') || '英文颜色',
    field: 'orderGoodsColorEn',
    width: 150,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
    editRender: {
      name: 'input',
      attrs: {
        type: 'String',
        placeholder:
          that.$l('tips_goods_label_orderGoodsColorEn') || '请输入英文颜色',
          maxlength: 50,
      },
    },
  },
  {
    title: 'Item#',
    field: 'Item',
    minWidth: 90,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
    editRender: {
      name: 'input',
      attrs: {
        type: 'String',
        placeholder: that.$l('tips_goods_label_item#') || '请输入item#',
        maxlength: 200,
      },
    },
  },
  {
    title: 'UPC',
    field: 'UPC',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
    editRender: {
      name: 'input',
      attrs: {
        type: 'String',
        placeholder: that.$l('tips_goods_label_UPC') || '请输入UPC',
        maxlength: 200,
      },
    },
  },
  {
    title: that.$l('goods_label_qty') || '数量',
    field: 'qty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        max: 999999,
        min: 0,
        step: 1,
      },
      placeholder: that.$l('tips_goods_label_qty') || '请输入数量',
      // immediate: true,
      autoselect: true,
    },
  },
]
